const tpdAutomaticClassification = {
  namespaced: true,
  state: {
    selected: {
      ecuApplication: '',
      products: [],
      faultCodes: [],
      softwareVersions: [],
      periodTypes: [],
      dateFrom: '',
      dateTo: '',
      classificationType: '',
      comment: '',
      dateAndTime: {
        raw: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        },
        formatted: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        }
      }
    }
  },
  mutations: {
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    setDefaultState (state) {
      state.selected = {
        ecuApplication: '',
        products: [],
        faultCodes: [],
        softwareVersions: [],
        dateFrom: '',
        dateTo: '',
        classificationType: '',
        comment: ''
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        ecuApplication: '',
        products: [],
        faultCodes: [],
        softwareVersions: [],
        dateFrom: '',
        dateTo: '',
        classificationType: '',
        comment: '',
        dateAndTime: {
          raw: {
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          },
          formatted: {
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          }
        }
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default tpdAutomaticClassification
